import type { SearchPageData, SearchQuery } from "@/lib/types/search"
import type { SearchGateway } from "@/platform/api/gateways/search"

import { buildSearchPageData, queryToApiPayload, type SearchItemsOptions } from "./search"

export const searchItems = async (gateway: SearchGateway, query: SearchQuery, page: number, options?: SearchItemsOptions, signal?: AbortSignal): Promise<SearchPageData> =>
  buildSearchPageData(await gateway.items(queryToApiPayload(query, page, options), signal), page)
